import React from "react";
import InformationToolTip from "../Utility/Helpers/InformationToolTip";
import Select from "react-select";

function SubCategoryFilters({
  fundingSubRTCDShow,
  fundingSubRDShow,
  fundingSubSBShow,
  career_stage,
  handleCareerStage,
  careerStageSelected,
  handlePDPI,
  pdpiSelected,
  subcategory_rtcd,
  handleFundingSubCategory_RTCD,
  fundingSubCategory_RTCD,
  subcategory_rd,
  handleFundingSubCategory_RD,
  fundingSubCategory_RD,
  subcategory_sb,
  handleFundingSubCategory_SB,
  fundingSubCategory_SB,
  isSmallScreen,
  InformationToolTipOptions,
}) {
  return (
    <>
      <div>
        {fundingSubRTCDShow && (
          <>
            <div className="col-12 mb-2">
              <div className="fw-bold">
                Research Training and Career Development Filters
              </div>
            </div>
            <div className="row d-flex justify-content-between">
              <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                <div className="mb-3 sub-filters-caption">
                  Program Type
                  <InformationToolTip
                    content={InformationToolTipOptions.rtcd}
                  />
                </div>
                <Select
                  options={subcategory_rtcd}
                  isMulti
                  onChange={handleFundingSubCategory_RTCD}
                  hideSelectedOptions={false}
                  value={fundingSubCategory_RTCD}
                />
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                <div>
                  <div className="mb-3 sub-filters-caption">
                    Career Stage
                    <InformationToolTip
                      content={InformationToolTipOptions.careerStage}
                    />
                  </div>
                  <Select
                    options={career_stage}
                    isMulti
                    onChange={handleCareerStage}
                    hideSelectedOptions={false}
                    value={careerStageSelected}
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                <div className="mb-3 sub-filters-caption">
                  PD/PI Citizenship Requirements
                  <InformationToolTip
                    content={InformationToolTipOptions.pdpi}
                  />
                </div>
                <label role="button" className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    value="Y"
                    name="pdpi"
                    onChange={handlePDPI}
                    checked={pdpiSelected === "Y"}
                  />
                  <span className="form-check-label">Yes</span>
                </label>
                <label role="button" className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    value="N"
                    name="pdpi"
                    onChange={handlePDPI}
                    checked={pdpiSelected === "N"}
                  />
                  <span className="form-check-label">No</span>
                </label>
              </div>
            </div>
          </>
        )}

        <div className="row d-flex">
          {fundingSubRDShow && (
            <>
              <div className="col-12">
                <div className="mb-2">
                  <div className="fw-bold">
                    Research and Development Filters
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-sm-12 mb-3 me-4">
                <div className="mb-3 sub-filters-caption">
                  Program Type
                  <InformationToolTip content={InformationToolTipOptions.rd} />
                </div>
                <Select
                  options={subcategory_rd}
                  isMulti
                  onChange={handleFundingSubCategory_RD}
                  hideSelectedOptions={false}
                  value={fundingSubCategory_RD}
                />
              </div>
            </>
          )}

          {fundingSubSBShow && (
            <>
              <div className="col-12">
                <div className="mb-2">
                  <div className="fw-bold">Small Business Filters</div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                <div className="mb-3 sub-filters-caption">
                  Program Type
                  <InformationToolTip content={InformationToolTipOptions.sb} />
                </div>
                <Select
                  options={subcategory_sb}
                  isMulti
                  onChange={handleFundingSubCategory_SB}
                  hideSelectedOptions={false}
                  value={fundingSubCategory_SB}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default SubCategoryFilters;
